module.exports = __webpack_public_path__ + "static/media/paypal-png-image-37936.36aabd55.png";